function submit_webpay (token) {
    window.location.replace('https://api.convergepay.com/hosted-payments' + '?ssl_txn_auth_token=' + token);
    return false;
}

function check_account_value(account_value) {
    const is_reg = /^\d{1,10}$/;
    let account_match = is_reg.test(account_value.trim());
    return account_match == null ? 'FALSE' : account_match;
}
function check_is (acc_id, cust_id) {
    let acc_test = check_account_value(acc_id);
    let cust_test = check_account_value(cust_id);
    
    return acc_test == cust_test ? 'TRUE' : 'FALSE';
    
}
const luhn_check = (function (cc_string) {
    return function (ccNum) {
        let 
            len = ccNum.length,
            bit = 1,
            sum = 0,
            val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? cc_string[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));



jQuery( document ).ready(function($) {
    $('#form_account_check').submit(function( event ) {
        event.preventDefault();
        let account_fields = {};
        $.each($('#form_account_check').serializeArray(), function(i, field) {
            account_fields[field.name] = field.value;
        });
        if (check_is(account_fields['customerid'], account_fields['invoiceid']) == 'TRUE') {
            $('#account_form_submit').prop('disabled', true);
            //check form validity
            let Form = document.getElementById("form_account_check");
            if(Form.checkValidity()){ 
                //form is valid

                let form = $("#form_account_check");
                let serial_array = form.serializeArray();
                let json_data;
                $('.waiting_spinner').css('display','block');
                $('.form-field input').attr('disabled','true');
                $('.overlay').addClass('show_overlay');
                let start_time = Date.now();
                //console.log(serial_array)
                $.ajax({
                    method: "POST",
                    url: '/includes/account.ajax.inc.php',
                    data: serial_array
                }).done(function(data) {
                    //console.log(data);
                    //return;
                    json_data = JSON.parse(data);
                    if(json_data.success == 'true') {
                        $('#global_status').text(json_data.payload.message);
                        $('#form_payment_amount').val(json_data.payload.InvoiceAmount).data('total_amount', json_data.payload.InvoiceAmount);
                        $('#invoiceid').val(json_data.payload.InvoiceID);
                        $('#customerid').val(json_data.payload.CustomerID);
                        $('#form_account_check').css('display','none');
                        $('#form_process_cc').css('display','block');
                    }
                    else {
                        $('#global_status').text(json_data.payload.message);
                    }
                    $('.waiting_spinner').css('display','none');
                    $('.form-field input').removeAttr('disabled');
                    $('.overlay').removeClass('show_overlay');
                    //let response_time = parseInt(Date.now()) - parseInt(start_time);
                    //$('#time_response').text('Response Time: ' + response_time + ' ms');
                    $('#account_form_submit').prop('disabled', false);
                });
            }
            else{
                $('#account_form_submit').prop('disabled', false);
            }
        }
        else {
            let error_msg_id = '';
            $.each(account_fields, function( index, value ) {
                error_msg_id = '#' + $(value).attr('id') + '_errormsg';
                display_msg(error_msg_id, 'Invalid ' + $(this).attr('placeholder'));
            });
        }
    });
    $('#form_account_check input:text').blur(function(){
        let error_msg_id = '#' + $(this).attr('id') + '_errormsg';
        if(check_account_value($(this).val()) == 'FALSE') {
            display_msg(error_msg_id, 'Invalid ' + $(this).attr('placeholder'));
            $('#account_form_submit').prop('disabled', true);
        }
        else {
            $(error_msg_id).text('');
            $('#account_form_submit').prop('disabled', false);
        }
    });
    $('input[name=form_payment_full_amount]:radio').on('change', function() {
        //console.log($('#form_payment_amount').data('total_amount'));
        if($(this).val() == 'Yes') {
            $('#form_payment_amount').val($('#form_payment_amount').data('total_amount'));
            $('#form_payment_amount').attr('disabled', 'disabled');
        }
        else {
            $('#form_payment_amount').removeAttr('disabled');
        }
     });
    $('#form_process_cc').submit(function( event ) {
        event.preventDefault();
        let Form = document.getElementById("form_process_cc");
        if(Form.checkValidity()){ 
            //form is valid
            let form = $("#form_process_cc");
            let serial_array = form.serializeArray();
            //let json_data;
            $('.waiting_spinner').css('display','block');
            $('.form-field input').attr('disabled','true');
            $('.overlay').addClass('show_overlay');
            $.ajax({
                method: "POST",
                url: '/includes/account.ajax.inc.php',
                data: serial_array
            }).done(function(data) {
                //console.log(data);
                submit_webpay (data);
            });
        }
    });

    function display_msg(msg_id, msg) {
        $(msg_id).text(msg);
    }
});
